import axios from 'axios'

export default {
  createOrder (order) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/orders', order).then((response) => {
      return response
    })
  },
  createOrderForTemporaryCustomer (order) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/ordersForTemporaryCustomer', order).then((response) => {
      return response
    })
  },
  createOrderItem (orderItem) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/orderitems', orderItem).then((response) => {
      return response
    })
  },
  deleteOrderItem (orderItemProductId) {
    return axios.delete(process.env.VUE_APP_BACKEND_BASE_URL + '/orderitems/' + orderItemProductId).then((response) => {
      return response
    })
  },
  getOrderItemsByCategoryForCustomer (category) {
    return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/orderitems/' + category.categoryId).then((response) => {
      return response
    })
  },
  getOrderItemsForCustomer () {
    return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/orderitems/').then((response) => {
      return response
    })
  },
  copyOrderItemsFromCustomer (fromDebtorNumberToId) {
    return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/orderitems/copy/', fromDebtorNumberToId).then((response) => {
      return response
    })
  }
}
